import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from '@/core/api/base-service';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { FuncaoRequest } from '@/core/api/sicom-api/registro/medico/funcao/funcao.model';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { environment } from '../../../../../../../environments/environment';
import { SICOM_PATHS } from 'src/sicom-paths';
import { buildPageableQuery, Pageable } from '@/shared/models/pageable.model';

@Injectable({ providedIn: 'root' })
export class FuncaoService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }
    readonly PATH = SICOM_PATHS.registro.medico.funcao;

    private pessoaParams(p: Pessoa): HttpParams {
        return new HttpParams().set('id', String(p.id)).set('uf', String(p.uf));
    }

    buscar(params: Pessoa, pageable?: Pageable, context?: HttpContext): Observable<FuncaoRequest[]> {
        let httpParam = this.pessoaParams(params);
        if (pageable) httpParam = buildPageableQuery(httpParam, pageable);
        return this.http.get<FuncaoRequest[]>(`${this.PATH}/consulta`, { params: httpParam, context });
    }
}
